var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-scrollbar',{attrs:{"wrapClass":"scrollbar-wrapper"}},[_c('el-menu',{attrs:{"default-active":_vm.$route.path,"show-timeout":200,"mode":"vertical","unique-opened":"","router":""}},[_c('div',{staticClass:"brand-mark-title"},[_vm._v("店铺管理")]),_c('sidebar-item',{attrs:{"routes":_vm.routes}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }